import { combineReducers } from "redux";

import get_inquiry from "../features/admin/expert/get_inquiry/Slice";

const expert = combineReducers({
  get_inquiry,
});

export default expert;
